export default "__VITE_ASSET__6iA6wGpr__"